import { createSlice } from "@reduxjs/toolkit";
import Offer from "../../../utils/OfferClass/Offer/Offer";
import { OfferType } from "../../../utils/types";
import { getReferralCode } from "../http/getReferralCode";

export interface InitialState {
  phoneNumberInfo: {
    phoneNumber: string;
    countryCode: string;
    isValid?: boolean;
  };
  username?: string;
  referralCode: {
    promoCode: {
      name: string;
      packageOffer?: OfferType;
      countPerUse: number;
      expired: boolean;
    };
    rewardedPoints: number;
    remainingInvitations: number;
  };
  tableNumber: number;
  token?: string;
  offerData?: {
    packageOffer: Offer;
    isRedeemed: boolean;
  };
  customerShortId?: string;
  userExtraInfo?: {
    email?: string;
    organization?: string;
    title?: string;
  };
}

const initialState: InitialState = {
  phoneNumberInfo: {
    phoneNumber: "",
    countryCode: "",
  },
  referralCode: {
    promoCode: {
      name: "",
      packageOffer: undefined,
      countPerUse: 0,
      expired: false,
    },
    rewardedPoints: 0,
    remainingInvitations: 0,
  },
  tableNumber: 1,
};

const config = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setPhoneNumberInfo: (state, action) => {
      state.phoneNumberInfo = action.payload;
    },
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setTableNumber: (state, action) => {
      state.tableNumber = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setReferralCode: (state, action) => {
      state.referralCode = action.payload;
    },
    setOfferData: (state, action) => {
      state.offerData = action.payload;
    },
    setUserExtraInfo: (state, action) => {
      state.userExtraInfo = action.payload;
    },
    setCustomerShortId: (state, action) => {
      state.customerShortId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReferralCode.fulfilled, (state, { payload }) => {
      state.referralCode = payload;
    });
  },
});

export const {
  setPhoneNumberInfo,
  setUsername,
  setTableNumber,
  setToken,
  setReferralCode,
  setOfferData,
  setCustomerShortId,
  setUserExtraInfo,
} = config.actions;

export default config.reducer;
